import { Injectable } from '@angular/core'
import { IModelBase } from 'common-components'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IPhoneType extends IModelBase {
  Id: number
  Name: string
  IsActive: boolean
}

@Injectable()
export class PhoneTypeODataService extends ODataService<IPhoneType> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'PhoneTypes'
  }
}
